// src/components/Home.jsx
import React from "react";
import { Container } from "react-bootstrap";
import "../css/chisono.css";

function importAll(r) {
  return r.keys().map(r);
}
const coachRugbyImages = importAll(
  require.context("../assets/coach-rugby", false, /\.(png|jpe?g|webp)$/)
);

export default function Chisono() {
  return (
    <main className="about1 py-5">
      <Container>
        {/* HERO */}
        <header className="about1-hero">
          <h1 className="about1-title">LYLE JOUBERT — FITNESS & COACHING</h1>
          <p className="about1-lead">
            Results-driven personal trainer with 5+ years on the gym floor,
            helping clients and athletes reach health and performance goals.
            Specialized in strength &amp; conditioning with an evidence-based,
            habit-focused approach.
          </p>
        </header>

        {/* BODY */}
        <div className="about1-grid">
          {/* Professional Summary */}
          <section className="about1-section">
            <h2 className="section-heading">Professional Summary</h2>
            <p>
              I combine evidence-based programming with motivational coaching to
              deliver tailored paths—one-to-one, small group, and online.
              Training emphasizes movement quality, progressive overload, and
              sustainable routines. My background as a professional rugby player
              in Italy’s Serie A (7 championships, 2017–2025) shapes the way I
              build resilient athletes and healthy lifestyles.
            </p>
          </section>

          {/* Experience */}
          <section className="about1-section">
            <h2 className="section-heading">Experience</h2>

            <div className="timeline">
              <article className="timeline-item">
                <div className="timeline-meta">
                  <span className="when">Sep 2020 — Present</span>
                  <span className="where">
                    SMASH Sport Center, Via Toscana - PESARO
                  </span>
                </div>
                <h3 className="role">Instructor & Personal Trainer</h3>
                <p className="desc">
                  Weights-room instructor since 11/09/2020; personal and private
                  coaching since 2021. Programs aimed at performance, health,
                  and overall well-being, fostering balanced, sustainable
                  habits.
                </p>
              </article>

              <article className="timeline-item">
                <div className="timeline-meta">
                  <span className="when">Nov 2017 — Jun 2025</span>
                  <span className="where">Serie A, Italy</span>
                </div>
                <h3 className="role">Professional Rugby Player</h3>
                <p className="desc">
                  Seven championships played in Italy. Athletic background
                  integrated into strength &amp; conditioning methods for
                  clients across levels.
                </p>
              </article>
            </div>
          </section>

          {/* Education */}
          <section className="about1-section">
            <h2 className="section-heading">Education</h2>
            <p className="edu">
              <strong>
                Bachelor of Education (Further Education &amp; Training)
              </strong>
              <br />
              Human Movement Science &amp; Sports Management — University of
              Pretoria (TUKS)
            </p>
          </section>

          {/* Personal Details (non-contact) */}
       
        </div>
        {/* COACH RUGBY COLLAGE 2x2 FULL-WIDTH */}
        <section className="coach-collage-wrap">
          <div className="coach-collage">
            {coachRugbyImages.slice(0, 4).map((src, i) => (
              <div className="coach-tile" key={i}>
                <img src={src} alt={`Coach rugby ${i + 1}`} />
              </div>
            ))}
          </div>
        </section>
      </Container>
    </main>
  );
}
